// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum ChangedChargeProperty {
  Unknown = "UNKNOWN",
  LicensePlate = "LICENSE_PLATE",
  ValidSince = "VALID_SINCE",
  Email = "EMAIL",
  PhoneNumber = "PHONE_NUMBER",
  FuelType = "FUEL_TYPE",
  EmailNotifications = "EMAIL_NOTIFICATIONS",
  SmsNotifications = "SMS_NOTIFICATIONS",
  Country = "COUNTRY",
}
export default ChangedChargeProperty;
